$(document).ready(function() {

    const myCurrentProductHandleParts = window.location.href.split("?");
    const myCurrentPageParts = window.location.href.split("/pages/");
    const productInfoUrl = myCurrentProductHandleParts[0] + '.json';
    let viewedoffers = Cookies.get('viewedoffers');
    let allowrun = 1;
  	let offers = [];
  
  	if (typeof wirelessslide !== 'undefined') {
		offers.push("wireless");
  	}
  
  	if (typeof cdsslide !== 'undefined') {
		offers.push("cds");
  	}
  
  	if (typeof sleepphonesslide !== 'undefined') {
		offers.push("sleepphones");
  	}
  
  	if (typeof mp3sslide !== 'undefined') {
		offers.push("mp3s");
  	}

    jQuery.getJSON(productInfoUrl, function(obj) {
        if (obj.product !== undefined) {
            const producthandle = obj.product.handle;
            if (producthandle == 'buy-2-cds-get-1-free' || producthandle == 'buy-3-mp3s-and-get-1-free' || producthandle == 'sleepphones-with-1-free-download' || producthandle == 'wireless-sleepphones-with-2-free-downloads') {
                allowrun = 0;
            }
        }

        if (myCurrentPageParts.length > 0) {
            if (myCurrentPageParts[1] == 'meditation-masterclass' || myCurrentPageParts[1] == 'brain-wave-chart' || myCurrentPageParts[1] == 'free-guided-meditation') {
                allowrun = 0;
            }
        }

        if (allowrun == 1) {
            setTimeout(function() { alertFunc() }, 5000);
            myStartFunction();
        }
    });

    if (viewedoffers == null) {
        var obj = [];
        var myJSON = JSON.stringify(obj);
        Cookies.set('viewedoffers', myJSON, { expires: 1 });
    }

    // setTimeout(function(){ alertFunc() }, 1000);

    function myStartFunction() {
        myVar = setInterval(function() { alertFunc(); }, 25000);
    }

    function alertFunc(viewedoffers) {
        viewedoffers = Cookies.get('viewedoffers');
        var viewdoffersobj = JSON.parse(viewedoffers);

        // console.log(viewdoffersobj);
        let breakloop = 0;
        let runoffer = '';
        for (let nindex = 0; nindex < offers.length; nindex++) {
            let tryoffer = offers[nindex];
            let curinarray = viewdoffersobj.includes(tryoffer);
            if (breakloop == 0) {
                if (curinarray == false) {
                    viewdoffersobj.push(tryoffer);
                    var newJSON = JSON.stringify(viewdoffersobj);
                    Cookies.set('viewedoffers', newJSON, { expires: 1 });
                    runoffer = tryoffer;
                    breakloop = 1;
                }
            }
        }

        if (runoffer && allowrun == 1) {
            let modalmessage = '';

            if (runoffer == 'wireless') {
                modalmessage = '<div class="slidinoffer"> <a class="desktoponly" href="/products/wireless-sleepphones-with-2-free-downloads"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/wireless-slidein.gif?v=1599388346" alt=""> </a> <a class="mobileonly" href="/products/wireless-sleepphones-with-2-free-downloads"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/wireless-promo-square_sm.gif?v=1599388325" alt=""> </a> </div>';
            }

           if (runoffer == 'cds') {
               modalmessage = '<div class="slidinoffer"> <a class="desktoponly" href="/products/buy-2-cds-get-1-free"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/buy-2-cds-horiz_b.gif?v=1599488850" alt=""> </a> <a class="mobileonly" href="/products/buy-2-cds-get-1-free"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/buy-2cd-get-1-free_sm.gif?v=1599488942" alt=""> </a> </div>';
           }

            if (runoffer == 'sleepphones') {
                modalmessage = '<div class="slidinoffer"> <a class="desktoponly" href="/products/sleepphones-with-1-free-download"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/sleephones-offer-horiz.gif?v=1599388324" alt=""> </a> <a class="mobileonly" href="/products/sleepphones-with-1-free-download"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/sleepphones-promo_sm.gif?v=1599388325" alt=""> </a> </div>';
            }

            if (runoffer == 'mp3s') {
                modalmessage = '<div class="slidinoffer"> <a class="desktoponly" href="/products/buy-3-mp3s-and-get-1-free"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/buy-3-mp3s-horiz.gif?v=1599388324" alt=""> </a> <a class="mobileonly" href="/products/buy-3-mp3s-and-get-1-free"> <img src="https://cdn.shopify.com/s/files/1/0024/7532/7537/files/buy-3-mp3s-get-1-free_sm.gif?v=1599388324" alt=""> </a> </div>';
            }

            jQuery('#animatedModal').html(modalmessage);

            $.fancybox.open({
                src: '#animatedModal',
                type: 'inline',
                opts: {
                    afterShow: function(instance, current) {
                        setTimeout(function() {
                            $.fancybox.close();
                        }, 3400);
                    }
                }
            });
        }

    }

    $(".logo-list-container").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });

    $(".bottomscrollinner").slick({
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ],
    });

    $(".reviewsshowinner").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });

    $('.faqcat').click(function(e) {
        e.preventDefault();
        let faqid = this.id;
        faqid = faqid.substring(3);

        $('.faqitemsnode').each(function(index, element) {
            $(this).removeClass('active');
        });


        $('#node' + faqid).addClass('active');

        $('.faqcats').removeClass('active');
        $('.faqitemswrap').addClass('active');

    });

    $('.faqback').click(function(e) {
        e.preventDefault();
        $('.faqcats').addClass('active');
        $('.faqitemswrap').removeClass('active');
    });

    $('.codesubmit').click(function(event) {
        let codeinput = $('.codeinputtext').val();
        codeinput = codeinput.toLowerCase();
        if (codeinput === 'meditateme') {
            window.location.href = "/pages/brain-power-improve-your-mind-as-you-age-audio-program";
        } else {
            $('.codeerror').addClass('show');
        }
    });

    $(".secquotescrollinner").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });

    $('.prdtab button').click(function(e) {
        e.preventDefault();
        $('.prdtab button').each(function(index, element) {
            $(this).removeClass('active');
        });
        $('.tabcntitem').each(function(index, element) {
            $(this).removeClass('active');
        });
        $(this).addClass('active');
        let tabid = this.id;
        tabid = tabid.substring(0, tabid.length - 3);
        $('#' + tabid).addClass('active');
    });

    $('.collectiontop a').click(function(e) {
        e.preventDefault();
        let topcontainer = $('#lowercontent').position().top - 200;
        $('html, body').animate({ scrollTop: topcontainer }, 'slow');
    });

    $('.phead').click(function(e) {
      e.preventDefault();
      let pbody = $(this).find(".toggle");
                     
      $(this).next().slideToggle("fast", function() {
      	var vis = $(this).is(":hidden");
        if (vis == true) {
        	pbody.html('+');
        } else {
        	pbody.html('-');
        }
  	  });

  	});
});